import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ token, css }: any) => ({
  root: css``,
  title: css``,
  titleIcon: css``,
  breadcrumb: css`
    padding-block: 12px;
    border-bottom: 1px solid ${token.ColorFigmaNeutralGrayscaleGray20};
  `,
}));

export const useHeaderStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
